import type { ShowTopToastOptions } from '@/lib/topToastTypes';

type Handlers = {
  showTopToast: (o: ShowTopToastOptions) => void;
  dismissTopToast: () => void;
};

const ref: { current: Handlers | null } = { current: null };

export const topToastBus = {
  bind(h: Handlers) {
    ref.current = h;
  },
  unbind() {
    ref.current = null;
  },
  show(opts: ShowTopToastOptions) {
    ref.current?.showTopToast(opts);
  },
  dismiss() {
    ref.current?.dismissTopToast();
  },
};
